module.exports = __webpack_public_path__ + "img/news2.c374e9fc.jpg";